export
const name: string = "Grass";

export
const preproc: string = `
    // Hack for SSAO, even if it is enabled, do not render it on grass
    #ifdef SSAO
    #undef SSAO
    #endif
`;

export
const declaration: string = `
    uniform sampler2D u_texture0;
    uniform sampler2D u_texture1;
    uniform sampler2D u_texture2;
    uniform sampler2D u_texture3;

    uniform sampler2D u_heightTexture; // Special texture for grass cutoff under model
`;

export
const varyings: string = `
    varying vec2    v_random;
    varying vec2    v_texcoords;
    varying vec4    v_relativePosition;
`;

export
const implementation: string = `
    void main()
    {
    #ifdef CLIPPING_PLANE
        if (resolveClippingPlane()) {
            gl_FragColor = vec4(clippingPlaneColor, 1.0);
            return;
        }
    #endif

        // Resolve height
        vec2 relative = v_relativePosition.xy / v_relativePosition.w * 0.5 + 0.5;
        vec4 heightData = texture2D(u_heightTexture, relative);

        // Test if any data was written
        if (heightData.x < 1.0 && heightData.y < 1.0 && heightData.z < 1.0 && heightData.w < 1.0) {
            float height = - vec4ToFloat(heightData);
            if (v_relativePosition.z / v_relativePosition.w >= height) {
                discard;
            }
        }

        // Get color (use more textures)
        vec2 texcoords = vec2(v_texcoords.x, 1.0 - v_texcoords.y);
        vec4 color;
        if (v_random[1] < 0.0025) {
            color = texture2D(u_texture0, texcoords);
        }
        else if (v_random[1] < 0.005) {
            color = texture2D(u_texture1, texcoords);
        }
        else if (v_random[1] < 0.15) {
            color = texture2D(u_texture2, texcoords);
        }
        else {
            color = texture2D(u_texture3, texcoords);
        }

        // Hack for devices without sampleAlphaToCoverage
        color.a = pow(color.a, 4.0);
        if (color.a <= 0.25) {
            discard;
        }

        // Copy from opaque
        SMaterial surfaceMat;
        surfaceMat.ambient = vec3(0.2);
        surfaceMat.diffuse = color.rgb;
        surfaceMat.specular = vec3(0.1);
        surfaceMat.emissive = vec3(0.0);
        surfaceMat.transparency = 0.0;
        surfaceMat.shininess = 0.0;
        surfaceMat.two_sided_lighting = 0;
        surfaceMat.alpha =  color.a;
        surfaceMat.shading = 0;

        // Get result color
        gl_FragColor = applyLighting(surfaceMat);

        // Something about depth :D
    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
